import EventEmitter from "events";
import addModuleToWorklet from "src/modules/audio-processing/addModuleToWorklet";
import { getModulePublicPathPrefix } from "src/utils/environment";

const DEFAULT_SENSITIVITY = 0.5;
const DEFAULT_SENSITIVITY_CORRECTION = 0;

const DefaultConfig = {
  numberOfInputs: 1, // interval: [1, 32]
  numberOfOutputs: 1,
  channelCount: 1,
  volumeFall: 0.1, // interval: [0,1]
  throttle: 2 //  interval: [1, 10]
};

export default async function createNoiseMeter(
  {
    audioContext,
    sourceNode,
    sensitivity: initialSensitivity,
    correction: initialSensitivityCorrection
  },
  config = {}
) {
  config = { ...DefaultConfig, ...config };
  let volume = 0;
  let sensitivity = initialSensitivity || DEFAULT_SENSITIVITY;
  let correction =
    initialSensitivityCorrection || DEFAULT_SENSITIVITY_CORRECTION;
  let frameId = null;

  const releaseResources = await addModuleToWorklet(
    audioContext.audioWorklet,
    getModulePublicPathPrefix() +
      "modules/audio-processing/worklets/noise-meter.js"
  );

  const audioWorkletNode = new AudioWorkletNode(audioContext, "noise-meter", {
    numberOfInputs: config.numberOfInputs,
    numberOfOutputs: config.numberOfOutputs,
    channelCount: config.channelCount
  });
  audioWorkletNode.port.onmessage = (e) => {
    const { name, payload } = e.data;
    if (name === "volume-change") {
      volume = payload;
      announceChange();
      return;
    }
  };
  audioWorkletNode.port.postMessage({
    name: "start",
    payload: {
      sensitivity,
      correction,
      throttle: config.throttle,
      volumeFall: config.volumeFall
    }
  });

  const eventEmitter = new EventEmitter();

  function announceChange() {
    eventEmitter.emit("change", volume);
  }

  announceChange();

  return Object.assign(eventEmitter, {
    audioNode: audioWorkletNode,
    getVolume: () => volume,
    setSensitivity: (sensitivity, correction) => {
      audioWorkletNode.port.postMessage({
        name: "sensitivity",
        payload: { sensitivity, correction }
      });
    },
    destroy: () => {
      window.cancelAnimationFrame(frameId);
      if (audioWorkletNode) {
        audioWorkletNode.port.postMessage({ name: "finish" });
        audioWorkletNode.disconnect();
      }
      releaseResources && releaseResources();
    }
  });
}
